'use strict';

function isRealNaN(obj) {
  // This is only true of NaN
  return obj != null && obj !== obj;
}

module.exports = isRealNaN;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/isRealNaN.js
// module id = 453
// module chunks = 0